
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.50842 2.16602H13.4918C14.909 2.16605 15.9798 2.5867 16.6949 3.30273C17.41 4.01867 17.8286 5.08917 17.8248 6.50586V13.4912C17.8248 14.9082 17.4043 15.979 16.6881 16.6953C15.9717 17.4117 14.9003 17.833 13.483 17.833H6.50842C5.0912 17.833 4.01966 17.4125 3.30334 16.6953C2.58698 15.978 2.16663 14.9042 2.16663 13.4824V6.50781C2.16663 5.09058 2.58697 4.01911 3.30334 3.30273C4.01972 2.58636 5.09119 2.16602 6.50842 2.16602ZM9.36682 4.99902C8.56572 4.99902 7.9167 5.64814 7.91663 6.44922V9.15918C7.75065 8.93076 7.48187 8.78237 7.17542 8.78223H5.38342C4.58237 8.78223 3.93337 9.4314 3.93323 10.2324V14.083C3.9334 14.5923 4.34085 14.999 4.85022 14.999H7.17542C7.54422 14.9988 7.85776 14.7849 8.00354 14.4736C8.14929 14.7852 8.46444 14.999 8.83362 14.999H11.1578C11.4822 14.999 11.7656 14.8344 11.9283 14.583H12.0553C12.2181 14.8342 12.5006 14.999 12.8248 14.999H15.15C15.6594 14.999 16.0668 14.5923 16.067 14.083V11.6572C16.0668 10.8564 15.4177 10.2081 14.6168 10.208H12.8248C12.5184 10.208 12.2497 10.3556 12.0836 10.584V6.44922C12.0835 5.64818 11.4345 4.99909 10.6334 4.99902H9.36682Z"
      fill="#222222"
      stroke="#222222"
    />
  </svg>
</template>
        
<script>
export default {
  name: "ActivityDumpIcon",
  data() {
    return {};
  },
  computed: {},
};
</script>
